import React from 'react';
import ReactDOM from 'react-dom';
import { Modal, ModalContent } from '@tesla/design-system-react';
import Tabs from './Tabs.js';
import { useNavConfigContext } from '../Context/index.js';

var MenuModal = function MenuModal() {
  var _useNavConfigContext = useNavConfigContext(),
    openMobileMenu = _useNavConfigContext.openMobileMenu,
    isMobileView = _useNavConfigContext.isMobileView,
    setOpenMobileMenu = _useNavConfigContext.setOpenMobileMenu,
    containerName = _useNavConfigContext.containerName;
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(Modal, {
    onClose: function onClose() {
      return setOpenMobileMenu(false);
    },
    open: openMobileMenu && isMobileView,
    variant: "fullscreen"
  }, /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement(Tabs, null))), document.querySelector(containerName));
};

export { MenuModal as default };
